<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Wrapper: viewport-locked so the page never grows a second scrollbar beside the canvas. -->
<div class="empty-layout">
    <div class="empty-layout__content">
        <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
        <router-outlet *ngIf="true"></router-outlet>
    </div>
</div>
